import useMediaQuery from "@mui/material/useMediaQuery";
export default function useAppMediaQuery(size?: string) {
  return useMediaQuery(size || "(max-width:800px)");
}
